import { render, staticRenderFns } from "./SupplierRecruit.vue?vue&type=template&id=81c0737e&scoped=true&"
import script from "./SupplierRecruit.vue?vue&type=script&lang=js&"
export * from "./SupplierRecruit.vue?vue&type=script&lang=js&"
import style0 from "./SupplierRecruit.vue?vue&type=style&index=0&id=81c0737e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c0737e",
  null
  
)

export default component.exports